import React from "react";
import PortalShell from "./PortalShell";
import { useT } from "@/context/I18nContext";
import { isPlatformOwner, isSuperAdmin, isOccupationalHealth } from "@/context/AuthContext";
import { LayoutDashboard, Building2, Users, CreditCard, Activity, MailPlus, MessagesSquare, KeyRound, ScrollText, ShieldCheck, Stethoscope, Users2, Settings } from "lucide-react";

/** Platform Owner portal — replaces the outdated SUPER section. */
export function OwnerShell() {
  const t = useT();
  const items = () => [
    { key: "overview", to: "/owner", end: true, label: t("nav.overview"), icon: LayoutDashboard },
    { key: "orgs", to: "/owner/organizations", label: t("b2b.nav.organisations"), icon: Building2 },
    { key: "users", to: "/owner/users", label: t("nav.users"), icon: Users },
    { key: "billing", to: "/owner/billing", label: t("b2b.nav.billing"), icon: CreditCard },
    { key: "usage", to: "/owner/usage", label: t("nav.usage"), icon: Activity },
    { key: "invites", to: "/owner/invites", label: t("nav.invites"), icon: MailPlus },
    { key: "feedback", to: "/owner/feedback", label: t("nav.feedback"), icon: MessagesSquare },
    { key: "beta", to: "/owner/beta", label: t("nav.beta"), icon: KeyRound },
    { key: "roles", to: "/owner/roles", label: t("b2b.nav.roles"), icon: ShieldCheck },
    { key: "audit", to: "/owner/audit", label: t("nav.audit"), icon: ScrollText },
    { key: "settings", to: "/app/settings", label: t("nav.settings"), icon: Settings },
  ];
  return (
    <PortalShell title={t("b2b.nav.owner")} subtitle={() => "Inner Compass"} items={items}
      allow={(roles) => isPlatformOwner(roles) || isSuperAdmin(roles)} testPrefix="owner" headerLabel={t("b2b.nav.owner")} />
  );
}

/** Occupational Health (bedrijfsarts) portal — separate permission model from HR. */
export function OhShell() {
  const t = useT();
  const items = () => [
    { key: "overview", to: "/oh", end: true, label: t("nav.overview"), icon: Stethoscope },
    { key: "clients", to: "/oh/clients", label: t("b2b.oh.clients"), icon: Users2 },
    { key: "settings", to: "/app/settings", label: t("nav.settings"), icon: Settings },
  ];
  return (
    <PortalShell title={t("b2b.nav.oh")} subtitle={() => t("b2b.oh.subtitle")} items={items}
      allow={(roles) => isOccupationalHealth(roles) || isPlatformOwner(roles)} testPrefix="oh" headerLabel={t("b2b.nav.oh")} />
  );
}
